export const postalCodeData = [
  {
    territoryId: 'AL',
    regex: '\\d{4}',
  },
  {
    territoryId: 'AR',
    regex: '([A-HJ-NP-Z])?\\d{4}([A-Z]{3})?',
  },
  {
    territoryId: 'AT',
    regex: '\\d{4}',
  },
  {
    territoryId: 'AU',
    regex: '\\d{4}',
  },
  {
    territoryId: 'BE',
    regex: '\\d{4}',
  },
  {
    territoryId: 'BG',
    regex: '\\d{4}',
  },
  {
    territoryId: 'BN',
    regex: '[A-Z]{2}[ ]?\\d{4}',
  },
  {
    territoryId: 'BR',
    regex: '\\d{5}[\\-]?\\d{3}',
  },
  {
    territoryId: 'BY',
    regex: '\\d{6}',
  },
  {
    territoryId: 'C2',
    regex: '\\d{6}',
  },
  {
    territoryId: 'CA',
    regex:
      '[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][ ]?\\d[ABCEGHJ-NPRSTV-Z]\\d',
  },
  {
    territoryId: 'CH',
    regex: '\\d{4}',
  },
  {
    territoryId: 'CL',
    regex: '\\d{7}',
  },
  {
    territoryId: 'CN',
    regex: '\\d{6}',
  },
  {
    territoryId: 'CO',
    regex: '\\d{6}',
  },
  {
    territoryId: 'CR',
    regex: '\\d{4,5}|\\d{3}-\\d{4}',
  },
  {
    territoryId: 'CY',
    regex: '\\d{4}',
  },
  {
    territoryId: 'CZ',
    regex: '\\d{3}[ ]?\\d{2}',
  },
  {
    territoryId: 'DE',
    regex: '\\d{5}',
  },
  {
    territoryId: 'DK',
    regex: '\\d{4}',
  },
  {
    territoryId: 'DO',
    regex: '\\d{5}',
  },
  {
    territoryId: 'EC',
    regex: '\\d{6}',
  },
  {
    territoryId: 'EE',
    regex: '\\d{5}',
  },
  {
    territoryId: 'ES',
    regex: '\\d{5}',
  },
  {
    territoryId: 'FI',
    regex: '\\d{5}',
  },
  {
    territoryId: 'FM',
    // "regex": "(9694[1-4])([ \\-]\\d{4})?"
    regex: '(\\d{4})([ \\-]\\d{4})?',
  },
  {
    territoryId: 'FO',
    regex: 'FO-\\d{3}',
  },
  {
    territoryId: 'FR',
    // "regex": "\\d{2}[ ]?\\d{3}"
    regex: '\\d{5}',
  },
  {
    territoryId: 'GB',
    regex:
      'GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\\d{1,4}',
  },
  {
    territoryId: 'GF',
    regex: '9[78]3\\d{2}',
  },
  {
    territoryId: 'GL',
    regex: 'DK-39\\d{2}',
  },
  {
    territoryId: 'GP',
    regex: '9[78][01]\\d{2}',
  },
  {
    territoryId: 'GR',
    regex: '\\d{3}[ ]?\\d{2}',
  },

  {
    territoryId: 'HR',
    regex: '\\d{5}',
  },
  {
    territoryId: 'HU',
    regex: '\\d{4}',
  },
  {
    territoryId: 'ID',
    regex: '\\d{5}',
  },

  {
    territoryId: 'IL',
    regex: '\\d{7}',
  },
  {
    territoryId: 'IN',
    regex: '\\d{6}',
  },
  {
    territoryId: 'IS',
    regex: '\\d{3}',
  },
  {
    territoryId: 'IT',
    regex: '\\d{5}',
  },
  {
    territoryId: 'JP',
    regex: '\\d{3}-\\d{4}',
  },
  {
    territoryId: 'KG',
    regex: '\\d{6}',
  },

  {
    territoryId: 'KH',
    regex: '\\d{5}',
  },
  {
    territoryId: 'KR',
    regex: '\\d{5}',
  },
  {
    territoryId: 'KW',
    regex: '\\d{5}',
  },
  {
    territoryId: 'KZ',
    // "regex": "\\d{6}"
    // 7位字符
    regex: '.{7}',
  },
  {
    territoryId: 'LA',
    regex: '\\d{5}',
  },
  {
    territoryId: 'LK',
    regex: '\\d{5}',
  },

  {
    territoryId: 'LT',
    regex: '\\d{5}',
  },

  {
    territoryId: 'LU',
    regex: '\\d{4}',
  },
  {
    territoryId: 'LV',
    regex: 'LV-\\d{4}',
  },

  {
    territoryId: 'MA',
    regex: '\\d{5}',
  },
  {
    territoryId: 'MC',
    regex: '980\\d{2}',
  },
  {
    territoryId: 'MD',
    regex: '\\d{4}',
  },
  {
    territoryId: 'ME',
    regex: '8\\d{4}',
  },
  {
    territoryId: 'MK',
    regex: '\\d{4}',
  },
  {
    territoryId: 'MN',
    regex: '\\d{5}',
  },
  {
    territoryId: 'MQ',
    regex: '9[78]2\\d{2}',
  },
  {
    territoryId: 'MT',
    regex: '[A-Z]{3}[ ]?\\d{2,4}',
  },
  {
    territoryId: 'MU',
    regex: '\\d{5}',
  },
  {
    territoryId: 'MV',
    regex: '\\d{5}',
  },
  {
    territoryId: 'MX',
    regex: '\\d{5}',
  },
  {
    territoryId: 'MY',
    regex: '\\d{5}',
  },

  {
    territoryId: 'NG',
    regex: '(\\d{6})?',
  },
  {
    territoryId: 'NL',
    regex: '\\d{4}[ ]?[A-Z]{2}',
  },
  {
    territoryId: 'NP',
    regex: '\\d{5}',
  },
  {
    territoryId: 'NZ',
    regex: '\\d{4}',
  },

  {
    territoryId: 'NO',
    regex: '\\d{4}',
  },
  {
    territoryId: 'OM',
    regex: '\\d{3}',
  },
  {
    territoryId: 'PK',
    regex: '\\d{5}',
  },
  {
    territoryId: 'PA',
    regex: '\\d{4}',
  },
  {
    territoryId: 'PE',
    regex: '\\d{5}',
  },
  {
    territoryId: 'PL',
    regex: '\\d{2}-\\d{3}',
  },
  {
    territoryId: 'PT',
    regex: '\\d{4}(\\d{3})?',
  },
  {
    territoryId: 'PY',
    regex: '\\d{4}',
  },
  {
    territoryId: 'RE',
    regex: '9[78]4\\d{2}',
  },
  {
    territoryId: 'RO',
    regex: '\\d{6}',
  },
  {
    territoryId: 'RS',
    regex: '\\d{5}|\\d{6}',
  },
  {
    territoryId: 'RU',
    regex: '\\d{6}',
  },

  {
    territoryId: 'SA',
    regex: '\\d{5}',
  },

  {
    territoryId: 'SE',
    regex: '\\d{3}[ ]?\\d{2}',
  },

  {
    territoryId: 'SI',
    regex: '\\d{4}',
  },
  {
    territoryId: 'SG',
    regex: '\\d{6}',
  },
  {
    territoryId: 'SK',
    regex: '\\d{3}[ ]?\\d{2}',
  },
  {
    territoryId: 'SM',
    regex: '4789\\d',
  },
  {
    territoryId: 'SV',
    regex: '\\d{4}',
  },
  {
    territoryId: 'TH',
    regex: '\\d{5}',
  },

  {
    territoryId: 'TR',
    regex: '\\d{5}',
  },
  {
    territoryId: 'TT',
    regex: '\\d{6}',
  },
  {
    territoryId: 'TW',
    regex: '\\d{3}(\\d{2})?',
  },
  {
    territoryId: 'UA',
    regex: '\\d{5}',
  },
  {
    territoryId: 'US',
    regex: '\\d{5}([ \\-]\\d{4})?',
  },
  {
    territoryId: 'UY',
    regex: '\\d{5}',
  },
  {
    territoryId: 'UZ',
    regex: '\A((100)[0-2]\d{2,2}|(11)[0-2][0-1]\d{2,2}|(12)[0-1][0 -1]\d{2,2}|(13)[0-1][1-3]\d{2,2}|(14)[0-1][1-6]\d{2, 2}|(15)[0-1][1-9]\d{2,2}|(16)[0-1][1-2]\d{2,2}|(17)[0 -1][1-6]\d{2,2}|(18)[0-1][1-4]\d{2,2}|(19)[0-1][1-5] \d{2,2}|(20)[0-1][1-2]\d{2,2}|(21)[0-1][0-1]\d{2,2}| (22)[0-1][1-2]\d{2,2}|(23)[0-1][1-6]\d{2,2})\Z'
  },
  {
    territoryId: 'VA',
    regex: '00120',
  },
  {
    territoryId: 'VE',
    regex: '\\d{4}',
  },
  {
    territoryId: 'VN',
    regex: '\\d{6}',
  },
  {
    territoryId: 'WS',
    regex: '\\d{4}',
  },
  {
    territoryId: 'YT',
    regex: '976\\d{2}',
  },
  {
    territoryId: 'ZA',
    regex: '\\d{4}',
  },
];
